export default __webpack_public_path__ + "static/media/media.d49b16d0.svg";